import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { QaQcTestResultEnum, RejectionReasonsEnum, ShiftsEnum } from '@gtpl/shared-models/common-models';
import { QcDefectItemDetailsDto } from './qc_defect_item_details_dto';
export class QcDefectDto{
    @ApiProperty()
    @IsNotEmpty({message:"QCDefect Id not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    qcId: number;

    @ApiProperty()
    @IsNotEmpty()
    lotNumber:string;

    @ApiProperty()
    workstationId:number;

    @ApiProperty()
    operationId:number;

    @ApiProperty()
    startTime:Date;

   @ApiProperty()
   inspectedCount:number;

   @ApiProperty()
   inspectedQuantity:number;

   @ApiProperty()
   passedQuantity:number;

    @ApiProperty()
    testResult: string;

    @ApiProperty()
    remarks: string;


    @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  unitId:number;

  @ApiProperty()
  versionFlag : number;
 
  @ApiProperty({type:QcDefectItemDetailsDto})
  qcDefectItemDetails:QcDefectItemDetailsDto[];

}